<template>

	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>Voorraad</h4>

		<c-table
			:columns="columns"
			:endpoint="endpoint"
			:search="false">
		</c-table>

		<div class="c-stock__button" @click="trigger('new-stock')" v-if="client_type_id == $constants.client.REUZADO || client_type_id == $constants.client.RESELLER || client_type_id == $constants.client.EINDKLANT ">
			<button class="c-btn c-btn--hollow no-margin">
				+ Toevoegen
			</button>
		</div>
	</div>

</template>

<script>
import CTable from '@components/table/Table';

export default {
	components: { CTable },
	props: {
		endpoint: {
			required: true,
		},
		client_type_id: {
			required: true,
		}
	},
	data() {
		return {

		}
	},
	methods: {
        trigger(event) {
           this.$store.dispatch('listener/emit', event);
		}
    },
	computed: {
		columns() {

			if(this.client_type_id == this.$constants.client.EINDGEBRUIKER){

				let columns = [
					{ name: 'product.name', label: 'Productnaam'},
					{ name: 'product.article_number', label: 'Artikelnr' },
					{ name: 'serial', label: 'serienummer'},
				];
				return columns;

			}
			else{
				let columns = [
					{ name: 'name', label: 'Productnaam'},
					{ name: 'article_number', label: 'Artikelnr' },
					{ name: 'items_in_stock', label: 'Voorraad'},
					{ name: 'available_items', label: 'Op afroep'},
					{ name: 'items_at_location', label: 'Klantlocatie'},
					{ name: 'items_in_use', label: 'In gebruik', sortable: true },

				];
				return columns;

			}

		},
	},
	mounted() {
	}
}
</script>
